export default __webpack_public_path__ + "mlp-sworl-md.fd8317b.png";